import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$fromEntries from "@babel/runtime-corejs3/core-js/object/from-entries";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";

/* eslint-disable camelcase */
import pick from "lodash/pick";
import camelcase from "lodash/camelCase";
const keysToKeep = ['first_name', 'last_name', 'wedding_date', 'legacy_user_id', 'email', 'username', 'budget', 'number_of_guests', 'created_at'];

const formatDate = dateString => dateString.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, '$3-$1-$2');

const findAddressByType = (addresses, type) => _findInstanceProperty(addresses).call(addresses, _ref => {
  let {
    address_type
  } = _ref;
  return address_type === type;
}) || null;

const addressToLocationString = addr => `${addr.city}, ${addr.state}`;

const mapObject = (object, callback) => {
  var _context;

  return _Object$fromEntries(_mapInstanceProperty(_context = _Object$entries(object)).call(_context, callback));
};

const toAnalyticsProperties = function (actualMemberData) {
  let addresses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const mappedMemberData = mapObject(pick(actualMemberData, keysToKeep), _ref2 => {
    let [key, value] = _ref2;
    const sanitizedValue = value || null;

    if (key === 'budget') {
      return ['weddingBudget', sanitizedValue];
    }

    if (key === 'number_of_guests') {
      return ['weddingSize', sanitizedValue];
    }

    if (key === 'wedding_date') {
      return ['weddingDate', sanitizedValue && formatDate(sanitizedValue)];
    }

    if (key === 'legacy_user_id') {
      return ['userId', sanitizedValue];
    }

    return [camelcase(key), sanitizedValue];
  });
  const weddingAddress = findAddressByType(addresses, 'wedding');
  const accountCreateAddress = findAddressByType(addresses, 'account_create');
  return { ...mappedMemberData,
    weddingLocation: weddingAddress && addressToLocationString(weddingAddress),
    weddingMarketCode: weddingAddress && weddingAddress.market_code,
    accountCreateMarketCode: accountCreateAddress && accountCreateAddress.market_code
  };
};

export default toAnalyticsProperties;